import { ModelSagres } from "./model-sagres";

export class ModelSagresDatatable extends ModelSagres {
  modoEdicao = false;
  loading = false;
  _rowVariant?: string;
  _showDetails = false;

  /** Este barata-voa serve para não enviar os 4 campos desta classe nas chamadas de API */
  toFormData(): FormData {
    const keyStrings = ["modoEdicao", "loading", "_rowVariant", "_showDetails"];
    const formData = super.toFormData();
    keyStrings.forEach((key) => {
      if (formData.get(key) !== null) formData.delete(key);
    });

    return formData;
  }
}
